module.exports = __webpack_public_path__ + "img/image27.ca3956af.jpg";